import React from 'react';

// Logo AV Kamas en pièce qui tourne — utilisé pour tous les états de chargement
export default function CoinLoader({ size = 56, label, fullPage = false }) {
  const coin = (
    <div className="coin-spin-wrap">
      <img
        src="/logo512.png"
        alt="AV Kamas"
        width={size}
        height={size}
        className="coin-spin rounded-full drop-shadow-[0_0_15px_rgba(250,204,21,0.35)]"
        style={{ width: size, height: size }}
      />
    </div>
  );

  if (!fullPage) {
    return (
      <div className="flex flex-col items-center justify-center gap-3 py-6">
        {coin}
        {label && <p className="text-gray-400 text-sm">{label}</p>}
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-950 text-white flex items-center justify-center">
      <div className="text-center">
        <div className="flex justify-center mb-4">{coin}</div>
        {label && <p className="text-gray-400">{label}</p>}
      </div>
    </div>
  );
}
